<template>
  <div :class="{content: true, empty: list && list.length === 0}">
    <div class="filters">
      <div class="cates">
        <div class="cate" v-for="(f, i) in filters" :key="i">
          <span class="name" v-if="f.key=='type_id'">{{filterOptions['class_id']==2?'基本类':filterOptions['class_id']==9?'拓展类':'类型'}}</span>
          <span class="name" v-else>{{f.title}}</span>
          <p v-if="c.type ? c.type === filterType : true" :class="{btn: true, on: c.selected}" v-for="(c, d) in f.list" :key="d" @click="selectFilter(c, f)">
            {{c.title}}
          </p>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="handles">
        <div class="left">
          <div class="btn" @click="delSelected()">
            <img src="@assets/img/resources/del.svg" alt="delete">
            <span class="name">删除</span>
          </div>
        </div>
        <div class="btn greenBtn" @click="openAdd(1)">
          <img src="@assets/img/resources/add.svg" alt="delete">
          <span class="name">添加</span>
        </div>
      </div>
      <div class="headline">
        <img :src="allChecked ? icons.checkerOn : icons.checker" alt="checker" class="checker" @click="checkAll()">
        <span class="number">人员编号</span>
        <span class="name">姓名</span>
        <span class="cate">分类</span>
        <span class="type">类型</span>
        <span class="status">当前状态</span>
        <span class="todos">待执行的休假</span>
        <span class="handle">
          操作
        </span>
      </div>
      <empty :mTop="30" :msg="'暂无人员数据'" v-if="list && list.length === 0" />
      <div v-for="(l, i) in list" :key="i">
        <div :class="{content: true, yellow: l.status == '休假'}">
          <div class="item">
            <img :src="l.checked ? icons.checkerOn :icons.checker" alt="checker" class="checker" @click="checkItem(l)">
            <span class="theme" @click="goDetail(l.id)">
              <p class="words" :title="l.idstring">
                {{l.idstring}}
              </p>
              <span class="msgIcon" v-if="l.remark">
                <img src="@assets/img/interview/msg.svg" alt="msg">
                <p class="msgContent">
                  {{l.remark}}
                </p>
              </span>
              <img src="@assets/img/interview/alert.svg" alt="warn" v-if="i.warn">
            </span>
            <span class="name">{{l.title}}</span>
            <span class="cate">{{l.class_title}}</span>
            <span class="type">{{l.type_title}}</span>
            <span class="status">{{l.status}}</span>
            <span class="todos" @click="toggleExpand(l)">
              <span>{{l.rest_list ? l.rest_list.length : 0}}</span>
              <img :src="l.expand ? icons.up : icons.down" alt="icon" class="icon">
            </span>
            <span class="handle">
              <span class="btn" @click="dealVacation(l)">休假</span>
            </span>
          </div>
        </div>
        <div class="childContent" v-for="(c, ci) in l.records" :key="ci + 1" v-if="l.expand">
          <div class="item">
            <span class="checker"></span>
            <span class="theme">
              <span class="tag">{{c.rest_type}}</span>
            </span>
            <span class="name">{{c.status_name}}</span>
            <span class="cate">
              <img src="@assets/img/resources/starttime.svg" alt="start">
              <span>
                {{c.rest_start}}
              </span>
            </span>
            <span class="type">
              <img src="@assets/img/resources/endtime.svg" alt="end">
              <span>
                {{c.rest_end}}
              </span>
            </span>
            <span class="handle">
              <span class="btn" v-if="c.status - 0 === 0" @click="cancelVacation(c.rest_id)">取消</span>
              <span class="btn" v-if="c.status - 0 === 1" @click="finishVacation(c.rest_id)">结束</span>
            </span>
          </div>
        </div>
      </div>
      <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
    </div>
    <addResource ref="addResource" />
    <dealVacation ref="dealVacation" />
  </div>
</template>

<script>
import pages from '@components/pages'
import addResource from '@components/addResource'
import dealVacation from '@components/dealVacation'
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'

export default {
  name: 'equipments',
  components: {
    pages, addResource, dealVacation, empty
  },
  data() {
    return {
      page: {
        page_count: 0,
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      icons: {
        checker: require('@assets/img/interview/checker.svg'),
        checkerOn: require('@assets/img/interview/checkerOn.svg'),
        up: require('@assets/img/topics/up.svg'),
        down: require('@assets/img/topics/down.svg')
      },
      filterOptions: {},
      filters: [],
      filterType: null,
      list: null,
      allChecked: false
    }
  },
  methods: {
    getVacations(id, item) {
      // 获取人员休假记录
      const info = {
        person_id: id
      }

      common.myFetch(apis.Res_people_rest, info)
      .then((data) => {
        this.$set(item, 'records', data.list)
      })
    },
    cancelVacation(id) {
      // 取消休假
      const info = {
        rest_id: id
      }
      common.myFetch(apis.Res_people_vacation_cancel, info)
      .then((data) => {
        if (data) {
          this.$toast(data)
        }
      })
    },
    finishVacation(id) {
      // 完成休假
      const info = {
        rest_id: id
      }

      common.myFetch(apis.Res_people_vacation_finish, info)
      .then((data) => {
        if (data) {
          this.$toast(data)
        }
      })
    },
    toggleExpand(i) {
      // 展开／收起休假列表
      if (!i.expand) {
        this.getVacations(i.id, i)
      }

      this.$set(i, 'expand', !i.expand)
    },
    selectFilter(i, f) {
      // 选择筛选条件
      if (i.selected) return

      this.page.pageIndex = 1

      f.list.forEach((s) => {
        s.selected = false
      })

      this.$set(i, 'selected', true)
      if (i.class) {
        this.filterType = i.class
      }
      this.filterOptions[f.key] = i.key
      this.$nextTick(() => {
        this.getList()
      })
    },
    goDetail(d) {
      // 跳转详情页
      // this.$router.push({
      //   path: '/peopleDetail',
      //   query: {
      //     d: d
      //   }
      // })

      common.jump(`/peopleDetail?d=${d}`, true)
    },
    checkAll() {
      // 全选
      const status = !this.allChecked

      this.list.forEach((i) => {
        this.$set(i, 'checked', status)
      })
      this.allChecked = status
    },
    checkItem(i) {
      // 单选
      this.$set(i, 'checked', !i.checked)

      this.$nextTick(() => {
        if (!i.checked) {
          this.allChecked = false
        }
      })
    },
    openAdd(t) {
      // 打开添加人员
      this.$refs.addResource.open(t)
    },
    dealVacation(l) {
      // 打开休假弹窗
      this.$refs.dealVacation.open(l)
    },
    getList() {
      // 获取列表
      const id = this.$route.params.id
      const info = {
        idstring: id,
        class_id: '',
        type_id: '',
        status: '',
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }
      Object.assign(info, this.filterOptions)

      common.myFetch(apis.Res_people_list, info)
      .then((data) => {
        this.list = data.list
        this.filters = data.params.list_search
        this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
        this.$set(this.page, 'total', data.page.row_count - 0)
      })
    },
    delSelected() {
      // 删除所选人员
      const selected =  []
      this.list.forEach(i => {
        if (i.checked) {
          selected.push(i.id)
        }
      })

      this.delPeople(selected.join(','))
    },
    delPeople(id) {
      // 删除人员
      if (id.length < 1) {
        this.$toast('请选择人员')
        return
      }

      const info = {
        person_ids: id
      }

      common.myFetch(apis.Res_people_del, info)
      .then((data) => {
        if (data) {
          this.$toast(data)
          this.getList()
        }
      })
    }
  },
  mounted() {
    this.getList()
  }
}
</script>

<style lang="less" src="@assets/css/resource/people.less" scoped></style>
